import { Alert, Stack } from "@mui/material";

export const AlertasSistema = ({ limites }) => {
  if (!limites) return null;

  const hoy = new Date();
  const diasEnMes = new Date(hoy.getFullYear(), hoy.getMonth() + 1, 0).getDate();
  const diasRestantes = diasEnMes - hoy.getDate();
  const diasTranscurridos = hoy.getDate();

  const alerts = [];

  const check = (nombre, info) => {
    if (!info || info.ilimitado) return;

    const { permitido, usado, restante } = info;
    if (permitido <= 0) return;

    const pct = (usado / permitido) * 100;

    if (restante <= 0 || pct >= 100) {
      alerts.push({ severity: "error", text: `🚨 ${nombre}: LÍMITE ALCANZADO (${usado}/${permitido})` });
    } else if (pct >= 90) {
      alerts.push({ severity: "error", text: `🔴 ${nombre}: consumo crítico — ${Math.round(pct)}% usado, solo ${restante} restantes` });
    } else if (pct >= 70) {
      alerts.push({ severity: "warning", text: `⚠️ ${nombre}: consumo alto — ${Math.round(pct)}% usado` });
    }

    // Proyección de consumo para fin de mes
    if (diasTranscurridos > 0 && diasRestantes > 0 && usado > 0) {
      const consumoDiario = usado / diasTranscurridos;
      const proyectado = Math.round(consumoDiario * diasRestantes);
      if (proyectado > restante && pct < 100) {
        alerts.push({
          severity: "warning",
          text: `📈 ${nombre}: a este ritmo superarías el límite antes de fin de mes (proyección: +${proyectado} usos en ${diasRestantes} días restantes)`,
        });
      }
    }
  };

  check("Consultas", limites.consultas);
  check("Búsquedas", limites.busquedas);
  check("Descargas", limites.descargas);

  if (alerts.length === 0) return null;

  return (
    <Stack spacing={1} sx={{ mb: 2 }}>
      {alerts.map((a, i) => (
        <Alert key={i} severity={a.severity} variant="filled">
          {a.text}
        </Alert>
      ))}
    </Stack>
  );
};
